(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-homepage-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHome = (scope = document) => {
      const roots = scope.matches?.('.mc-home')
        ? [scope]
        : scope.querySelectorAll?.('.mc-home') || [];

      roots.forEach((root) => {
        if (root.dataset.mcHomeInitialized === 'true') return;
        root.dataset.mcHomeInitialized = 'true';

        const hero = root.querySelector('.mc-home__hero');
        const video = root.querySelector('.mc-home__video');

        if (hero && video) {
          const hideSeconds = Number.parseFloat(hero.dataset.overlayHideSeconds || '2.5');
          const syncOverlay = () => {
            if (!Number.isFinite(video.duration) || video.duration <= 0) return;
            const shouldHide = video.currentTime >= Math.max(0, video.duration - hideSeconds);
            hero.classList.toggle('mc-home__hero--ending', shouldHide);
          };

          const playButton = root.querySelector('[data-mc-home-video-play]');
          const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
          const effectiveType = connection?.effectiveType || '';
          const slowConnection = Boolean(
            connection?.saveData ||
            ['slow-2g', '2g'].includes(effectiveType)
          );
          let autoplayRetries = 0;

          const showPlayFallback = () => {
            if (playButton) playButton.hidden = false;
            video.dataset.autoplayBlocked = 'true';
          };

          const hidePlayFallback = () => {
            if (playButton) playButton.hidden = true;
            delete video.dataset.autoplayBlocked;
          };

          const prepareVideo = () => {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
          };

          const startHeroVideo = ({ userInitiated = false } = {}) => {
            prepareVideo();

            if (slowConnection && !userInitiated) {
              video.pause();
              video.autoplay = false;
              video.removeAttribute('autoplay');
              video.preload = 'none';
              showPlayFallback();
              return;
            }

            hidePlayFallback();
            video.autoplay = true;
            video.setAttribute('autoplay', '');
            video.preload = 'metadata';

            const playPromise = video.play();
            if (playPromise?.then) {
              playPromise.then(() => {
                autoplayRetries = 0;
                hidePlayFallback();
              }).catch(() => {
                if (slowConnection) {
                  showPlayFallback();
                  return;
                }

                hidePlayFallback();
                if (!userInitiated && autoplayRetries < 3) {
                  autoplayRetries += 1;
                  window.setTimeout(() => startHeroVideo(), 1200 * autoplayRetries);
                }
              });
            } else if (!video.paused) {
              autoplayRetries = 0;
              hidePlayFallback();
            }
          };

          playButton?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            video.controls = false;
            startHeroVideo({ userInitiated: true });
          });

          hero.addEventListener('click', (event) => {
            if (event.target.closest('a, button')) return;

            video.controls = false;

            if (video.paused || video.ended) {
              startHeroVideo({ userInitiated: true });
            } else {
              video.pause();
            }
          });

          video.addEventListener('loadedmetadata', syncOverlay);
          video.addEventListener('timeupdate', syncOverlay);
          video.addEventListener('seeking', syncOverlay);
          video.addEventListener('play', () => {
            autoplayRetries = 0;
            hidePlayFallback();
            syncOverlay();
          });
          video.addEventListener('pause', () => {
            if (!video.ended) showPlayFallback();
          });

          video.addEventListener('ended', () => {
            showPlayFallback();
          });

          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.preload = 'none';
          showPlayFallback();
        }

        const rail = root.querySelector('[data-mc-home-rail]');
        const prev = root.querySelector('[data-mc-home-prev]');
        const next = root.querySelector('[data-mc-home-next]');

        if (rail) {
          const originals = Array.from(rail.querySelectorAll('.mc-home__card'));
          const originalCount = originals.length;
          let cards = originals;
          let railRaf = null;
          let fallbackSettleTimer = null;
          let isAnimating = false;

          if (originalCount > 1) {
            const fragment = document.createDocumentFragment();

            originals.forEach((card, index) => {
              const clone = card.cloneNode(true);
              clone.dataset.mcLoopCopy = 'before';
              clone.dataset.mcLoopItem = String(index);
              clone.setAttribute('aria-hidden', 'true');
              clone.querySelectorAll('a, button, input').forEach((el) => el.setAttribute('tabindex', '-1'));
              fragment.appendChild(clone);
            });

            originals.forEach((card, index) => {
              card.dataset.mcLoopItem = String(index);
              fragment.appendChild(card);
            });

            originals.forEach((card, index) => {
              const clone = card.cloneNode(true);
              clone.dataset.mcLoopCopy = 'after';
              clone.dataset.mcLoopItem = String(index);
              clone.setAttribute('aria-hidden', 'true');
              clone.querySelectorAll('a, button, input').forEach((el) => el.setAttribute('tabindex', '-1'));
              fragment.appendChild(clone);
            });

            rail.replaceChildren(fragment);
            cards = Array.from(rail.querySelectorAll('.mc-home__card'));
          }

          const getGap = () =>
            Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '16');

          const setEdgePadding = () => {
            const firstCard = cards[0];
            if (!firstCard) return;
            const inset = Math.max(0, (rail.clientWidth - firstCard.getBoundingClientRect().width) / 2);
            rail.style.paddingInline = `${inset}px`;
          };

          const targetLeftFor = (card) =>
            card.offsetLeft - Math.max(0, (rail.clientWidth - card.getBoundingClientRect().width) / 2);

          const getNearestIndex = () => {
            if (!cards.length) return 0;

            const railRect = rail.getBoundingClientRect();
            const railCenter = railRect.left + railRect.width / 2;
            let nearestIndex = 0;
            let nearestDistance = Number.POSITIVE_INFINITY;

            cards.forEach((card, index) => {
              const rect = card.getBoundingClientRect();
              const cardCenter = rect.left + rect.width / 2;
              const distance = Math.abs(cardCenter - railCenter);

              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            return nearestIndex;
          };

          const getSetSpan = () => {
            if (originalCount <= 1 || !cards[originalCount] || !cards[0]) return 0;
            return cards[originalCount].offsetLeft - cards[0].offsetLeft;
          };

          const jumpToLeft = (left) => {
            const previousBehavior = rail.style.scrollBehavior;
            const previousSnap = rail.style.scrollSnapType;
            const previousTransitions = cards.map((card) => card.style.transition);

            rail.style.scrollBehavior = 'auto';
            rail.style.scrollSnapType = 'none';

            cards.forEach((card) => {
              card.style.transition = 'none';
            });

            rail.scrollLeft = left;
            rail.getBoundingClientRect();
            updateCoverflow();

            requestAnimationFrame(() => {
              cards.forEach((card, index) => {
                card.style.transition = previousTransitions[index];
              });

              rail.style.scrollBehavior = previousBehavior;
              rail.style.scrollSnapType = previousSnap;
            });
          };

          const updateCoverflow = () => {
            railRaf = null;
            if (!cards.length) return;

            const railRect = rail.getBoundingClientRect();
            const railCenter = railRect.left + railRect.width / 2;
            const cardWidth = cards[0].getBoundingClientRect().width || 1;
            const step = cardWidth + getGap();

            let activeCard = cards[0];
            let nearestDistance = Number.POSITIVE_INFINITY;

            cards.forEach((card) => {
              const rect = card.getBoundingClientRect();
              const cardCenter = rect.left + rect.width / 2;
              const raw = (cardCenter - railCenter) / step;
              const distance = Math.min(2.2, Math.abs(raw));

              if (Math.abs(cardCenter - railCenter) < nearestDistance) {
                nearestDistance = Math.abs(cardCenter - railCenter);
                activeCard = card;
              }

              const direction = raw < 0 ? 1 : -1;
              const rotate = direction * Math.min(15, distance * 12);
              const scale = Math.max(0.84, 1 - distance * 0.085);
              const depth = -Math.min(120, distance * 82);
              const opacity = Math.max(0.48, 1 - distance * 0.22);

              card.style.transform = `translateZ(${depth}px) rotateY(${rotate}deg) scale(${scale})`;
              card.style.opacity = opacity.toFixed(3);
              card.style.filter = distance > 1.35 ? 'saturate(0.82)' : 'none';
              card.style.zIndex = String(Math.max(1, 10 - Math.round(distance * 4)));
              card.dataset.mcActive = 'false';
            });

            if (activeCard) activeCard.dataset.mcActive = 'true';
          };

          const queueCoverflow = () => {
            if (railRaf !== null) return;
            railRaf = requestAnimationFrame(updateCoverflow);
          };

          const recenterIfNeeded = () => {
            if (originalCount <= 1 || isAnimating) return;

            const index = getNearestIndex();
            const span = getSetSpan();
            if (!span) return;

            if (index < originalCount) {
              jumpToLeft(rail.scrollLeft + span);
            } else if (index >= originalCount * 2) {
              jumpToLeft(rail.scrollLeft - span);
            }
          };

          const animateToCard = (index) => {
            const card = cards[index];
            if (!card || isAnimating) return;

            const startLeft = rail.scrollLeft;
            const endLeft = targetLeftFor(card);
            const distance = endLeft - startLeft;

            if (Math.abs(distance) < 1) return;

            isAnimating = true;
            const previousSnap = rail.style.scrollSnapType;
            const previousBehavior = rail.style.scrollBehavior;
            rail.style.scrollSnapType = 'none';
            rail.style.scrollBehavior = 'auto';

            const duration = 420;
            const startTime = performance.now();

            const step = (now) => {
              const progress = Math.min(1, (now - startTime) / duration);
              const eased = progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2;

              rail.scrollLeft = startLeft + distance * eased;
              queueCoverflow();

              if (progress < 1) {
                requestAnimationFrame(step);
                return;
              }

              rail.scrollLeft = endLeft;
              rail.style.scrollSnapType = previousSnap;
              rail.style.scrollBehavior = previousBehavior;
              isAnimating = false;

              recenterIfNeeded();
              updateCoverflow();
            };

            requestAnimationFrame(step);
          };

          const move = (direction) => {
            if (originalCount <= 1 || isAnimating) return;

            const currentIndex = getNearestIndex();
            const targetIndex = currentIndex + direction;
            if (!cards[targetIndex]) return;

            animateToCard(targetIndex);
          };

          setEdgePadding();

          requestAnimationFrame(() => {
            if (originalCount > 1) {
              const firstReal = cards[originalCount];
              if (firstReal) {
                jumpToLeft(targetLeftFor(firstReal));
              }
            }
            updateCoverflow();
          });

          rail.addEventListener('scroll', () => {
            queueCoverflow();

            if (!isAnimating && !('onscrollend' in rail)) {
              window.clearTimeout(fallbackSettleTimer);
              fallbackSettleTimer = window.setTimeout(recenterIfNeeded, 220);
            }
          }, { passive: true });

          if ('onscrollend' in rail) {
            rail.addEventListener('scrollend', () => {
              if (!isAnimating) recenterIfNeeded();
            }, { passive: true });
          }

          const onResize = () => {
            if (!cards.length) return;

            const nearestIndex = getNearestIndex();
            const logicalIndex = originalCount > 1
              ? ((nearestIndex % originalCount) + originalCount) % originalCount
              : 0;

            setEdgePadding();

            requestAnimationFrame(() => {
              const targetIndex = originalCount > 1 ? originalCount + logicalIndex : 0;
              const card = cards[targetIndex];
              if (card) jumpToLeft(targetLeftFor(card));
              updateCoverflow();
            });
          };

          window.addEventListener('resize', onResize, { passive: true });

          prev?.addEventListener('click', (event) => {
            event.preventDefault();
            move(-1);
          });

          next?.addEventListener('click', (event) => {
            event.preventDefault();
            move(1);
          });
        }
      });
    };

    const start = () => initHome(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (!section) return;
      section.querySelectorAll?.('.mc-home').forEach((root) => {
        root.dataset.mcHomeInitialized = 'false';
        initHome(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
